import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import PortalIdParser from 'PortalIdParser';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import buildLiveChat from '../utils/buildLiveChat';
import { useSelector } from 'react-redux';
import { selectAuthenticatedUser } from '../selectors';
import styled from 'styled-components';
import { NavMarker } from 'react-rhumb';
import { useDispatch } from 'react-redux';
import { UsageTrackerUtils, IframeUtils, MessageUtils } from 'feature-unboxing-common';
import { getState } from '../utils/unboxingClient';
import Raven from 'raven-js';
import { goToUrl } from '../utils/locationUtils';
import useChatSlice from '../hooks/useChatSlice';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ExternalLinkIcon } from 'foundations-assets';
import { getChatflowsUrl } from '../utils/urls';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Button } from 'foundations-components/transitional/components/Button';
import { H3 } from 'foundations-components/transitional/components/H3';
import Confetti from 'growth-onboarding-confetti/Confetti';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  TrackerActions
} = UsageTrackerUtils;
const Wrapper = styled.div.withConfig({
  displayName: "CreateLiveChatLoader__Wrapper",
  componentId: "lhfp52-0"
})(["height:100vh;display:flex;justify-content:center;align-items:center;"]);
export default function CreateLiveChatLoader() {
  var _queryParams$get;
  const queryParams = new URLSearchParams(useLocation().search);
  const chatState = (_queryParams$get = queryParams.get('chatState')) !== null && _queryParams$get !== void 0 ? _queryParams$get : '';
  const user = useSelector(selectAuthenticatedUser);
  const {
    chat: chatInCookies
  } = useChatSlice();
  const [chat, setChat] = useState();
  const [chatCreated, setChatCreated] = useState(false);
  const dispatch = useDispatch();
  const portalId = PortalIdParser.get();
  const chatflowsUrl = getChatflowsUrl();
  const goToFallback = useCallback(() => {
    if (!IframeUtils.isInIframe()) goToUrl(`/home?portalId=${portalId}`);
  }, [portalId]);
  useEffect(() => {
    async function fetchChat() {
      setChat(await getState(chatState));
    }
    fetchChat().catch(e => {
      Raven.captureMessage('Failed to fetch chat', {
        extra: e
      });
      setChat(chatInCookies);
    });
  }, [chatState, goToFallback, chatInCookies]);
  useEffect(() => {
    dispatch(TrackerActions.trackPageView({
      screen: 'create-live-chat-page'
    }));
  }, [dispatch]);
  useEffect(() => {
    if (user && chat) {
      buildLiveChat({
        color: chat.accentColor,
        welcomeMessage: chat.welcomeMessage,
        customChatName: chat.customChatName
      }).then(() => {
        setChatCreated(true);
      }).catch(err => {
        Raven.captureMessage('Failed to build live chat', {
          extra: err
        });
        goToFallback();
      });
    }
  }, [user, chat, goToFallback]);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "CREATE_LOAD",
    children: /*#__PURE__*/_jsx(Wrapper, {
      children: !chatCreated ? /*#__PURE__*/_jsx(LoadingSpinner, {
        size: "medium"
      }) : IframeUtils.isInIframe() && /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx("div", {
          "data-test-id": "create-live-chat-confetti-container",
          children: /*#__PURE__*/_jsx(Confetti, {})
        }), /*#__PURE__*/_jsx(Illustration, {
          name: "success-green",
          width: "230px",
          marginBlock: "800"
        }), /*#__PURE__*/_jsx(H3, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.create.chatCreated"
          })
        }), /*#__PURE__*/_jsxs(Button, {
          onClick: MessageUtils.sendCloseIframeMessage,
          href: chatflowsUrl,
          target: "_blank",
          rel: "noopener noreferrer",
          use: "primary",
          "data-test-id": "create-live-chat-loader-cta",
          marginBlock: "200",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.create.clickHere"
          }), /*#__PURE__*/_jsx(View, {
            as: "span",
            marginInline: "200",
            children: /*#__PURE__*/_jsx(ExternalLinkIcon, {})
          })]
        })]
      })
    })
  });
}